module.exports = __webpack_public_path__ + "35025e03b82d56f573006e61a93b0631.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/drop.msgpack
 ** module id = 593
 ** module chunks = 0
 **/